import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-gray-200 bg-white print:hidden">
      <div className="container-app py-10">
        <div className="grid gap-8 md:grid-cols-4">
          <div>
            <h3 className="mb-3 text-lg font-bold text-primary-600">동탄 마스터 가이드</h3>
            <p className="text-sm text-gray-500">
              AI 기반 부동산 초정밀 가치 분석 플랫폼
            </p>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-gray-900">서비스</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/properties" className="hover:text-primary-600">매물 검색</Link></li>
              <li><Link to="/analysis/market" className="hover:text-primary-600">시장 분석</Link></li>
              <li><Link to="/engines" className="hover:text-primary-600">AI 분석 엔진</Link></li>
              <li><Link to="/simulation" className="hover:text-primary-600">투자 시뮬레이션</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-gray-900">동탄 정보</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/dongtan" className="hover:text-primary-600">동탄 개요</Link></li>
              <li><Link to="/dongtan/development" className="hover:text-primary-600">개발 계획</Link></li>
              <li><Link to="/dongtan/infrastructure" className="hover:text-primary-600">인프라 지도</Link></li>
              <li><Link to="/community" className="hover:text-primary-600">커뮤니티</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-3 text-sm font-semibold text-gray-900">고객지원</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/agents" className="hover:text-primary-600">중개사 찾기</Link></li>
              <li><a href="mailto:support@dongtan-guide.kr" className="hover:text-primary-600">이메일 문의</a></li>
            </ul>
          </div>
        </div>

        {/* 회사 정보 */}
        <div className="mt-8 border-t border-gray-100 pt-6">
          <div className="grid gap-4 text-xs text-gray-400 md:grid-cols-2">
            <div className="space-y-1">
              <p className="font-medium text-gray-500">(주)에이치제이브레인</p>
              <p>대표자명: 이선희 | 사업자등록번호: 821-87-01635</p>
              <p>개업연월일: 2020-04-20</p>
              <p>업태: 서비스 | 종목: 소프트웨어개발</p>
              <p>주소: 경기 용인시 기흥구 구갈로60번길 9-1 602-A100호(구갈동, 라파빌딩)</p>
            </div>
            <div className="space-y-1 md:text-right">
              <p>
                <Link to="/privacy" className="hover:text-primary-600">개인정보처리방침</Link>
                <span className="mx-2">|</span>
                <Link to="/terms" className="hover:text-primary-600">이용약관</Link>
              </p>
              <p>통신판매번호: 해당 없음</p>
              <p>문의: <a href="mailto:support@dongtan-guide.kr" className="hover:text-primary-600">support@dongtan-guide.kr</a></p>
            </div>
          </div>
        </div>

        <div className="mt-6 border-t border-gray-100 pt-4 text-center text-xs text-gray-400">
          &copy; {new Date().getFullYear()} (주)에이치제이브레인. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
